import React, { useContext, useEffect, useState } from "react";

//context and service
import { ContentAudienceContext }  from "./ContentAudienceContext";

//components
import BasicButton from "../global/buttons/BasicButton/BasicButton";
import RadioButtonList from "../global/lists/RadioButtonList/RadioButtonList";
import { ToastMessageType } from "../global/ToastNotification";

//interfaces
import { AudienceModalState, ResetAudienceOption } from "@/interfaces/ContentAudienceModal";
import { IRadioButtonItem } from "@/interfaces/radioButtonList";
import { LoadingSpinner } from "thrive-components";


const ResetAudience = ({contentTitle, setAudienceModalState, onConfirmResetClick}: {contentTitle: string, setAudienceModalState:(state:AudienceModalState) => void, onConfirmResetClick: (selectedReset: ResetAudienceOption, successCb: () => void, failureCb:() => void) => void}) => {
    const [radioSelection, setRadioSelection] = useState<ResetAudienceOption|undefined>();
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const { setToast, getAudienceCounts } = useContext(ContentAudienceContext)   

    useEffect(() => {
        if((document.querySelector('.ResetAudience') as HTMLDivElement)) {
            (document.querySelector('.ResetAudience') as HTMLDivElement).style.height = `210px`
        }
    }, [])

    const radioButtonItems: IRadioButtonItem[] = [
        {
            isChecked: radioSelection === ResetAudienceOption.SyncWithParent,
            content: <><span className='title'>Reset Custom Permissions</span> <p className='content'>This will reset the permissions for this content to match the settings of its parent(s).</p></>,
            onClick: () => toggleSelection(ResetAudienceOption.SyncWithParent)
        },
        {
            isChecked: radioSelection === ResetAudienceOption.RemoveAll,
            content: <><span className="title">Remove All</span> <p className='content'>This action will remove the audience from this content, keeping only admins and workspace editors.</p></>,
            onClick: () => toggleSelection(ResetAudienceOption.RemoveAll)
        }
    ];

    function toggleSelection(option: ResetAudienceOption){
        setRadioSelection(option);
    }

    function confirmReset() {
        setIsLoading(true);
        onConfirmResetClick(
            radioSelection,
           /*success callback*/
           () => {
            const message = radioSelection === ResetAudienceOption.SyncWithParent 
                ? 'Successfully synced with parent/workspace'
                : 'Successfully removed audience' 
            setToast({type: ToastMessageType.SUCCESS, message })
            getAudienceCounts();
            (window as any)?.functions?.refreshMainMenu?.();
            (window as any)?.functions?.refreshUGCGroups?.();
            setAudienceModalState(AudienceModalState.EditAudience);
           },
           /* failure callback */
           () => {
            const message = radioSelection === ResetAudienceOption.SyncWithParent 
            ? 'Could not sync with parent/workspace at this time'
            : 'Could not remove audience at this time' 
            setToast({type: ToastMessageType.WARNING, message });
            setAudienceModalState(AudienceModalState.EditAudience);
           }
        )
    }

    return (
        <section>
            <h2 className="reset-audience-header">Reset Audience - {contentTitle}</h2>
            
            <div className="reset-audience-content-wrapper">
                <RadioButtonList buttons={radioButtonItems} />
            </div>

            <div className="audience-modal-control-wrapper">
                <BasicButton className="back-button" content={'Back'} ariaLabel={'Back'} onButtonClick={() => setAudienceModalState(AudienceModalState.EditAudience)}/>
                <BasicButton className="confirm-audience-button" isClassicCMSBlue content={isLoading ? <LoadingSpinner size={10} /> : 'Confirm'} ariaLabel={'Confirm selection'} isDisabled={radioSelection === undefined} onButtonClick={() => confirmReset()}/>
            </div>
        </section>
    )
}

export default ResetAudience;